import React from "react";
import { TextField } from "@mui/material";
import Grid2 from "@mui/material/Grid2";
import { fieldLabel, fieldLabelTooltip } from "../../constants";
import { ProfileReadOnlyField } from "./ProfileReadOnlyField";
import { buildProfileInfoAdornment } from "../../profileInfoAdornment";
import { registrationTextFieldSx } from "../../profileFieldStyles";

export function FormField({ name, value, errorMessage, onChange, readOnly = false }) {
  const isPassword = name === "passwordSftp";
  const labelTip = fieldLabelTooltip(name);
  const labelText = fieldLabel(name);
  const fieldId = `vendor-field-${name}`;

  if (readOnly) {
    return (
      <ProfileReadOnlyField
        fieldId={fieldId}
        label={labelText}
        value={value}
        tooltip={labelTip}
        mask={isPassword}
      />
    );
  }

  let inputProps;
  if (name === "numeroTelefono" || name === "telefonoReferente") {
    inputProps = { maxLength: 15, inputMode: "numeric", pattern: "[0-9]*" };
  } else if (name === "codiceFiscale") {
    inputProps = { maxLength: 16, style: { textTransform: "uppercase" } };
  }

  return (
    <Grid2 xs={12} md={6}>
      <TextField
        id={fieldId}
        label={labelText}
        error={!!errorMessage}
        helperText={errorMessage || ""}
        fullWidth
        name={name}
        value={value ?? ""}
        onChange={onChange}
        variant="outlined"
        size="medium"
        sx={registrationTextFieldSx}
        type={isPassword ? "password" : "text"}
        autoComplete={isPassword ? "new-password" : undefined}
        inputProps={inputProps}
        InputProps={{
          endAdornment: buildProfileInfoAdornment(labelTip),
        }}
      />
    </Grid2>
  );
}
